<template>
    <form class="adminUser-form">
        <div class="columns">
            <div class="column">
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label"></label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <h3 class="title is-3" v-if="!isEdit">Create a new admin user</h3>
                            <h3 class="title is-3" v-if="isEdit">Edit this admin user</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>

        <div class="columns">
            <div class="column">
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Tenant Id:</label>
                    </div>
                    <!--
                    <b-select v-model="points" placeholder="Select some of points">
                        <option v-for="rewardPointType in rewardPointsTypes"
                                :value="rewardPointType">
                            {{rewardPointType}}
                        </option>
                    </b-select>
                   -->
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <b-input
                                        placeholder=""
                                        type="text"
                                        v-model="tenantId"
                                ></b-input>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Login or email:</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <b-input
                                        placeholder="Login or email"
                                        type="text"
                                        v-model="login"
                                ></b-input>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Password:</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <b-input
                                        placeholder=""
                                        type="text"
                                        v-model="password"
                                ></b-input>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="columns">
            <div class="column field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Admin type:</label>
                </div>
                <div class="field-body">
                    <b-field>
                        <b-radio
                                v-for="adminUserType of adminUserTypes" :key="adminUserType.code"
                                v-model="type"
                                :native-value="adminUserType.code"
                                type="is-link"
                        >
                            <div class="column field is-horizontal">
                                {{ adminUserType.label }}
                            </div>
                        </b-radio>
                    </b-field>
                </div>
            </div>
        </div>

        <div class="field is-grouped" style="margin-top: 40px;">
            <div class="control">
                <button class="button is-light btn-margin" @click.prevent="goToPreviousPage()">Back to users list
                </button>
            </div>
            <div class="control">
                <button class="button is-link" @click.prevent="addAdminUser" :disabled="isLoading" v-if="!isEdit">Create
                    this admin user
                </button>
                <button class="button is-link" @click.prevent="updateAdminUser" :disabled="isLoading" v-if="isEdit">
                    Update this admin user
                </button>
            </div>
        </div>

    </form>
</template>

<script>
    import adminUsersService from '../services/adminUsersService'
    import BField from 'buefy/src/components/field/Field'
    import displayHelper from '../helpers/display-helper'

    export default {
      name: 'adminUser-form',
      components: {
        BField,
      },
      created() {
        if (this.$route.params.id) {
          this.isEdit = true
          this.adminUserId = this.$route.params.id
          this.loadAdminUserById(this.adminUserId)
        }
      },
      data() {
        return {
          isLoading: false,

          // for update
          isEdit: false,
          adminUserLoaded: null,
          adminUserId: null,
          imagePreviewUrl: '',

          // standard form
          errorMessage: '',
          createMode: false,
          tenantId: '',
          login: '',
          password: '',
          isActive: true,
          type: 'admin',

          adminUser: '',

          adminUserTypes: [
            {
              code: 'admin',
              label: 'Admin',
            },
            {
              code: 'superadmin',
              label: 'Super Admin',
            }
          ],
          adminUserJson: ''
        }
      },
      methods: {
        loadAdminUserById: function (adminUserId) {
          this.isLoading = true
          adminUsersService.getAdminUserById(adminUserId)
                  .then((adminUser) => {
                    console.log('AdminUser received: ' + adminUserId)
                    console.log(adminUser)

                    this.adminUserLoaded = adminUser

                    this.userId = this.adminUserLoaded.userId
                    this.tenantId = this.adminUserLoaded.tenantId
                    this.login = this.adminUserLoaded.login
                    this.password = this.adminUserLoaded.password
                    this.isActive = this.adminUserLoaded.isActive
                    this.type = this.adminUserLoaded.type

                    this.isLoading = false
                  })
                  .catch((err) => {
                    displayHelper.displayError(this, 'Generic error: ' + err.message)
                    this.isLoading = false
                  })
        },
        addAdminUser() {
          this.isLoading = true
          const json = {
            userId: this.userId,
            tenantId: this.tenantId,
            login: this.login,
            password: this.password,
            isActive: this.isActive,
            type: this.type
          }
          this.adminUserJson = json
          adminUsersService.addNewAdminUser(this.adminUserJson, this.image)
                    .then(() => {
                      this.goToPreviousPage()
                    }).catch((error) => {
                      displayHelper.displayError(this, 'Create adminUser error: ' + error.message)
                    })
                    .finally(() => {
                      this.isLoading = false
                    })
          this.createMode = false
        },
        updateAdminUser() {
          this.isLoading = true
          const json = {
            userId: this.userId,
            tenantId: this.tenantId,
            login: this.login,
            password: this.password,
            isActive: this.isActive,
            type: this.type
          }
          this.adminUserJson = json
          adminUsersService.updateAdminUser(this.adminUserId, this.adminUserJson)
                  .then(() => {
                    this.goToPreviousPage()
                  }).catch((error) => {
                    displayHelper.displayError(this, 'Update adminUser error: id=' + this.adminUserId + ' >>' + error.message)
                  })
                  .finally(() => {
                    this.isLoading = false
                  })
          this.createMode = false
        },
        goToPreviousPage() {
          this.$router.push({name: 'AdminUsers'})
        },
      },
    }
</script>

<style scoped>
    .adminUser .is-horizontal .field-label {
        flex-grow: 0;
    }
    .adminUser label {
        margin-bottom: 0;
        width: 180px !important;
    }
    .adminUser .column .field {
        align-items: center;
    }
    .field-label {
        flex-grow: 0;
    }
    .field-label label {
        width: 180px !important;
    }
</style>
